export const CORE_COLUMN_PAGE = "Page";
export const CORE_COLUMN_PARA = "Para/Section No.";
export const CORE_COLUMN_CONTENT = "Content";

export const CORE_COLUMN_NAMES = [
  CORE_COLUMN_PAGE,
  CORE_COLUMN_PARA,
  CORE_COLUMN_CONTENT,
];

export const CORE_KEY_PAGE = "page";
export const CORE_KEY_PARA = "para";
export const CORE_KEY_CONTENT = "content";

export const CORE_DEFAULT_WIDTHS = {
  [CORE_KEY_PAGE]: 80,
  [CORE_KEY_PARA]: 160,
  [CORE_KEY_CONTENT]: 300,
};

export const getCoreColumns = (template) => [
  {
    key: CORE_KEY_PAGE,
    name: CORE_COLUMN_PAGE,
    hidden: Boolean(template?.pageHidden),
    width: template?.pageWidth ?? null,
  },
  {
    key: CORE_KEY_PARA,
    name: CORE_COLUMN_PARA,
    hidden: Boolean(template?.paraHidden),
    width: template?.paraWidth ?? null,
  },
  {
    key: CORE_KEY_CONTENT,
    name: CORE_COLUMN_CONTENT,
    hidden: false,
    width: template?.contentWidth ?? null,
  },
];
